import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "agup2_admin_token";
export const USER_TOKEN_KEY = "iq3b9_user_token";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  // Admin routes always use the admin token when present. Everything else
  // (personnel-authenticated + public tickets) falls back to the user token.
  const url = config.url || "";
  const adminToken = localStorage.getItem(TOKEN_KEY);
  const userToken = localStorage.getItem(USER_TOKEN_KEY);
  const isAdmin = url.startsWith("/admin/") || url.includes("/admin/");
  const token = isAdmin ? adminToken : (userToken || adminToken);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const url = err.config?.url || "";
      if (url.includes("/admin/")) {
        localStorage.removeItem(TOKEN_KEY);
      } else if (url.includes("/personnel/")) {
        localStorage.removeItem(USER_TOKEN_KEY);
      }
    }
    return Promise.reject(err);
  }
);
